export interface TabItemProps {
  id: string;
  children: React.ReactNode;
  hidden: boolean;
}

export const TabPanel = ({ id, children, hidden }: TabItemProps) => {
  return (
    <div
      role="tabpanel"
      id={`panel-${id}`}
      aria-labelledby={`tab-${id}`}
      hidden={hidden}
      className="preflight"
    >
      {children}
    </div>
  );
};
